export const filterCheck: any = {
  "Be-Secure Technology Stacks": true,
  "Open Source Project Type (COM)": true,
  "Industry (IND)": true,
  "Security Domain (SD)": true,
  "Technology Domain Composition (TD-C)": true,
  "Technology Domain (Usage) (TD-U)": true,
  "Languages": true
};

export const tecStack: any = {
  "DevOPS and Infrastructure Tool (DO)": "DO",
  "Language & Framework (L&F)": "L&F",
  "Application (A)": "A",
  "Distributed & Decentralized Application (DA)": "DA",
  "Open Source Security Tool (S)": "S"
};

export const SecurityDomain: any = {
  "Security Risk Management (SD-SRM)": "SD-SRM",
  "Application Security (SD-AS)": "SD-AS",
  "Data Security (SD-DS)": "SD-DS",
  "Infrastructure Security (SD-IS)": "SD-IS",
  "Security Operations (SD-SOC)": "SD-SOC",
  "Identiry Access Management (SD-IAM)": "SD-IAM",
  "Cloud Security (SD-CS)": "SD-CS",
  "Blockchain Security (SD-BS)": "SD-BS",
  "Network Security (SD-NS)": "SD-NS",
  "IOT/OT Security (SD-IoTS)": "SD-IoTS",
  "Cryptography (SD-Crypto)": "SD-Crypto",
};

export const TechnologyDomain: any = {
  "Web Development (TD-U-W)": "TD-U-W",
  "Artifical Intelligence / Machine Learning (TD-U-AI/ML)": "TD-U-AI/ML",
  "Database (TD-U-Db)": "TD-U-Db",
  "Messaging (TD-U-Msg)": "TD-U-Msg",
  "API Development (TD-U-ApD)": "TD-U-ApD",
  "Mobile Application (TD-U-MoA)": "TD-U-MoA",
  "Desktop Application (TD-U-DkA)": "TD-U-DkA",
  "Data Analytics (TD-U-DAA)": "TD-U-DAA",
  "IoT (TD-U-IoT)": "TD-U-IoT",
  "Blockchain (TD-U-Bln)": "TD-U-Bln"
};

export const Industry: any = {
  "Bank & Financial Institutions (BFSI)": "IND-BFSI",
  "Healthcare & Life Scienses (HLS)": "IND-HLS",
  "Consumer (CON)": "IND-CON",
  "Retail (RT)": "IND-RT",
  "Agritech (AgT)": "IND-AgT",
  "Education (ED)": "IND-ED",
  "Non Profit & Govt (NG)": "IND-NG",
  "Energy & Utilities (ENU)": "IND-ENU",
  "All (ALL)": "IND-ALL",
  "Automotive (AM)": "IND-AM",
  "Telecom (TEL)": "IND-TEL",
  "Cybersecurity (CyS)": "IND-CyS"
};

export const TechnologyDomainComposition: any = {
  "Client Application (TD-C-CA)": "TD-C-CA",
  "Server (TD-C-S)": "TD-C-S",
  "Web Application (TD-C-WA)": "TD-C-WA",
  "API clients (TD-C-A)": "TD-C-A",
  "Database (TD-C-D)": "TD-C-D",
  "Messaging (TD-C-M)": "TD-C-M",
  "Distributed Application (TD-C-DA)": "TD-C-DA",
  "Microservices (TD-C-Ms)": "TD-C-Ms",
  "Container (TD-C-C)": "TD-C-C",
  "Wallet App (TD-C-Wlt)": "TD-C-Wlt"
};

export const OpenSourceProjectType: any = {
  "Foundation led projects (COM-F)": "COM-F",
  "Community led projects (COM-C)": "COM-C"
};
